<template>
    <el-container v-if="componentShow">
        <el-main>
            <div style="width: 100%" :style="{height:tbHight}">
                <plx-table-grid
                        :big-data-checkbox=false
                        use-virtual
                        :row-height=36
                        ref="zmtable"
                        border
                        stripe
                        highlight-current-row
                        :height-change=false
                        :datas="tableData"
                        :show-summary="showFooter"
                        :summary-method="getSummaries"
                        :cell-style="cellStyle"
                        :cell-class-name="cellClass"
                        :pagination-show="false"
                        @current-change="handleCurrentChange"
                        @selection-change="handleSelectionChange"
                        @row-click="rowClick"
                        @cell-click="cellClick"
                        @select-all="selectAll"
                        @row-dblclick="rowDbClick"
                        @sort-change="sortChange">
                    <plx-table-column width="52"  align="center">
                        <template slot="header" slot-scope="scope">
                            <el-button type="text" v-if="tableNo" @click="openTableConfig()" style="padding-top: 0px;padding-bottom: 0px;">
                                <img src="../../assets/icon/tbConfig.png" alt="配置">
                            </el-button>
                            <span v-else>{{$t(i18nPage+'序号')}}</span>
                        </template>
                        <template slot-scope="scope" >
                            <span style="margin-left: -8px;">{{ scope.$index + 1 }}</span>
                        </template>
                    </plx-table-column>
                    <plx-table-column type="selection" width="52"  align="center" v-if="!singleSelect" />
                    <plx-table-column
                            v-for="column in tableCol"
                            :key="column.value"
                            :label="column.text"
                            :sortable="typeof column.sortable !== 'undefined' ? (column.sortable ? 'custom' : false) : column.children ? false : 'custom'"
                            :prop="column.value"
                            v-if="tableflag"
                            :width="column.width"
                            :show-overflow-tooltip=true
                            :align="column.align ? column.align : 'left'"
                            :header-align="column.children ? 'center' : 'left'">
                        <template slot-scope="scope" v-if="!column.children">
                            <zm-col :col="column" :row="scope.row" @contextmenu.prevent.native="openColMenu(column,scope.row,$event)"/>
                        </template>
                        <template v-if="column.children">
                            <plx-table-column
                                    v-for="child1 in column.children"
                                    :key="child1.value"
                                    :label="child1.text"
                                    :sortable="typeof child1.sortable !== 'undefined' ? (child1.sortable ? 'custom' : false) : child1.children ? false : 'custom'"
                                    :prop="child1.value"
                                    :width="child1.width"
                                    :show-overflow-tooltip=true
                                    :align="child1.align ? child1.align : 'left'"
                                    :header-align="child1.children ? 'center' : 'left'">
                                <template slot-scope="scope" v-if="!child1.children">
                                    <zm-col :col="child1" :row="scope.row" @contextmenu.prevent.native="openColMenu(child1,scope.row,$event)"/>
                                </template>
                                <template v-if="child1.children">
                                    <plx-table-column
                                            v-for="child2 in child1.children"
                                            :key="child2.value"
                                            :label="child2.text"
                                            :prop="child2.value"
                                            :sortable="typeof child2.sortable !== 'undefined' ? (child2.sortable ? 'custom' : false) : 'custom'"
                                            :width="child2.width"
                                            :show-overflow-tooltip=true
                                            :align="child2.align ? child2.align : 'left'"
                                            header-align="left">
                                        <template slot-scope="scope">
                                            <zm-col :col="child2" :row="scope.row" @contextmenu.prevent.native="openColMenu(child2,scope.row,$event)"/>
                                        </template>
                                    </plx-table-column>
                                </template>
                            </plx-table-column>
                        </template>
                    </plx-table-column>
                </plx-table-grid>
            </div>
            <zm-table-config v-if="tableNo" ref="zmtbconfig" :table-no="tableNo" :col="col" @saveconfig="saveConfig" @copyCol="copyCol"/>
        </el-main>
        <el-footer class="el-footer-cls" v-if="pagination">
            <el-pagination
                    @size-change="pageSizeChange"
                    @current-change="pageCurrentChange"
                    :current-page="pagobj.currentPage"
                    :page-sizes="pageSizes"
                    :page-size="pagobj.pageSize"
                    layout="prev,  pager, next, jumper, sizes, total"
                    :total="pagobj.total">
            </el-pagination>
        </el-footer>
        <ul v-show="visible" :style="{left: left+'px', top: top+'px'}" class="contextmenu">
            <!--<li @click="copyColData(1,$event)">复制列</li>-->
            <li @click="copyColData(3,$event)">{{$t(i18nPage+'复制选择行')}}</li>
            <li @click="copyColData(2,$event)">{{$t(i18nPage+'复制所有行')}}</li>
        </ul>
    </el-container>
</template>

<script>
    import ZmCol from './ZmCol.vue'
    import ZmTableConfig from './ZmTableConfig.vue'
    import xeUtil from 'xe-utils'

    export default {
        name:'ZmTable',
        beforeCreate() {
            this.i18nPage = 'component.ZmTable.';
        },
        components: {
            ZmCol,
            ZmTableConfig
        },
        data(){
            return {
                i18nPage : 'component.ZmTable.',
                pagobj:{
                    total:0,
                    pageSize:50,
                    currentPage:1
                },
                tableData:[],
                footerData:[],
                currentRow: null,
                multipleSelection: [],
                tbHight:'',
                configCols:null,
                tableflag:true,
                colMap:{},
                visible:false,
                left:0,
                top:0,
                menuCol:{},
                menuRow:{},
                isCtrl:false,
                isShift:false,
                tableScrollPosition:false,
                isNoQuery:false,
                componentShow:true,
                colRemoteMap:{},
                sortObj:{
                    prop: '',
                    order: ''
                },
                localData:[]
            }
        },
        props: {
            col: {
                type: Array
            },
            // data: {
            //     type: Array
            // },
            tableHeight:{
                type:Number,
                default:104
            },
            // clickRow:Function,
            pagination:{
                type:Boolean,
                default:false
            },
            singleSelect:{
                type:Boolean,
                default:true
            },
            showFooter:{
                type:Boolean,
                default:false
            },
            getParams:{
                type:Function,
                required: true
            },
            startQuery:{
                type:Boolean,
                default:true
            },
            isAuto:{
                type:Boolean,
                default:true
            },
            method:{
                type:String,
                default:'get'
            },
            cellStyle: [Object, Function],
            cellClass: [String, Function],
            tableNo:{
                type:String
            },
            loading:{
                type:Boolean,
                default:false
            },
            queryClean:{
                type:Boolean,
                default:false
            },
            timeout:{
                type:Number,
                default:20000
            },
            keepSort:{
                type:Boolean,
                default:false
            },
            localPage:{
                type:Boolean,
                default:false
            },
            pageSizes: {
                type: Array,
                default() {
                    return [50, 100, 200, 300];
                }
            },
        },
        computed:{
            tableCol:{
                get:function (){
                    return this.configCols || this.col;
                },
                set:function (cols) {
                    this.configCols = cols;
                }
            },
            /*newheight: function() {
                if(this.tableHeight){
                    if(this.pagination){
                        return (window.innerHeight - 118- this.tableHeight) +'px';
                    }else {
                        return (window.innerHeight - 86 - this.tableHeight) +'px';
                    }
                }
                return '';
            },*/
            tableClumns: function () {
                var cols = [];
                if(this.tableCol && this.tableCol.length > 0){
                    this.tableCol.forEach((column, index) => {
                        if(column.children && column.children.length > 0){
                            this.getColsFun(column.children,cols);
                        } else {
                            cols.push({
                                value:column.value,
                                filter:column.filter,
                                isFtFileter:column.isFtFileter
                            });
                        }
                    });
                }
                return cols;
            }
        },
        methods: {
            saveConfig(cols){
                this.tableflag = false;
                this.configCols = cols;
                this.$nextTick(() => {
                    this.tableflag = true;
                });

            },
            copyCol(option){
                let colFieldVals = [];
                //过滤掉不是数据列的列
                option.colFields.forEach((item,index) => {
                    if(item.value){
                        colFieldVals.push(item);
                    }
                });
                let copyStr = '';
                if(colFieldVals.length > 0 && this.tableData && this.tableData.length > 0){
                    this.tableData.forEach((item,index) => {
                        for (let i = 0; i<colFieldVals.length; i++){
                            if(i != 0){
                                copyStr += '\t';
                            }
                            let colf = colFieldVals[i];
                            //当字段有值是获取对应的值，如果是有格式化和过滤 则组装处理后的值
                            if(item[colf.value]){
                                if(colf.formatter){
                                    copyStr += colf.formatter(item[colf.value],item);
                                }else if(colf.filter){
                                    copyStr += this.$options.filters[colf.filter](item[colf.value])
                                }else{
                                    copyStr += item[colf.value];
                                }
                            }
                        }
                        copyStr += '\r\n';
                    });
                    //将内容复制到粘贴板
                    this.$zmClp.copy(copyStr,option.$event);
                } else {
                    this.$util.show(this.$t(this.i18nPage+'请选择数据列或未获取到数据'),1);
                }
            },
            getColsFun(columns,cols){
                columns.forEach((column, index) => {
                    if(column.children && column.children.length > 0){
                        this.getColsFun(column.children,cols);
                    } else {
                        cols.push({
                            value:column.value,
                            filter:column.filter,
                            isFtFileter:column.isFtFileter
                        });
                    }
                });
            },
            handleCurrentChange(row){
                this.currentRow = row;
                this.$emit('current-change',row);

            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.$emit('selection-change',val);
            },
            rowDbClick(row){
                this.$emit('row-dblclick',row);
            },
            rowClick(row){
                this.$emit('row-click',row);
            },
            cellClick(row, column, cell, event){
                if(!this.singleSelect){
                    //如果列类型为选择 表示为多选复选框，此时点击使用切换选择状态，否则请求其他选择行选择点击行
                    if("selection" == column.type){
                        this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(row);
                    }else{
                        //判断是否已经按住 ctrl或shift, ctrl时反选行选择状态，  shift时选中区间行，否则清空其他选择当前行
                        if(this.isCtrl){
                            this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(row);
                        }else if(this.isShift){
                            if(this.multipleSelection != null && this.multipleSelection.length > 0){
                                let beginRowIndex = this.tableData.indexOf(this.multipleSelection[0]);
                                let endRowIndex = this.tableData.indexOf(row);
                                if(beginRowIndex > -1 && endRowIndex > -1){
                                    if(beginRowIndex < endRowIndex){
                                        for(var i = beginRowIndex;i <= endRowIndex;i++){
                                            this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(this.tableData[i],true);
                                        }
                                    }else {
                                        for(var i = endRowIndex;i <= beginRowIndex;i++){
                                            this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(this.tableData[i],true);
                                        }
                                    }
                                }
                            }
                        } else {
                            this.$refs['zmtable'].$refs['singleTable'].clearSelection();
                            this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(row,true);
                        }
                    }
                }
            },
            selectAll(selection){
                /*if(selection && selection.length > 0){
                    this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                }*/
            },
            getSeleteRow(){
                if(this.singleSelect){
                    return this.currentRow;
                }else {
                    return this.multipleSelection;
                }
            },
            getTableData(){
                return this.tableData;
            },
            //获取统计行数据
            getFooterData(){
                if(this.showFooter){
                    return this.footerData;
                }
            },
            //设置统计行数据
            setFooterData(ftdata){
                if(this.showFooter){
                    this.footerData = ftdata;
                }
            },
            setTableData(data){
                this.tableData = data;
            },
            pageSizeChange(val) {
                this.pagobj.pageSize = val;
                if(this.localPage){
                    this.setLocalData();
                }else{
                    this.query(true);
                }

            },
            pageCurrentChange(val) {
                this.pagobj.currentPage = val;
                if(this.localPage){
                    this.setLocalData();
                }else{
                    this.query(true);
                }
            },
            getSummaries(param){
                // console.log('getSummaries')
                // console.log(param)
                // console.log(this.footerData)
                // console.log(this.tableClumns)
                const sums = [];
                if(this.footerData && this.footerData.length > 0){
                    var footerDatum = this.footerData[0];
                    if(!footerDatum){
                        return sums;
                    }
                    var beginindex = 2;
                    sums[0] = '';
                    if(this.singleSelect){
                        beginindex = 1;
                    }else{
                        sums[1] = '';
                    }
                    this.tableClumns.forEach((clumn, index) => {
                        if(footerDatum[clumn.value] || footerDatum[clumn.value] === 0){
                            if(footerDatum[clumn.value] === 0){
                                sums[beginindex] = '0';
                            }else{
                                if(clumn.isFtFileter && clumn.filter){
                                    sums[beginindex] = this.$options.filters[clumn.filter](footerDatum[clumn.value])
                                }else{
                                    sums[beginindex] = footerDatum[clumn.value];
                                }
                            }
                        }else{
                            sums[beginindex] = '';
                        }
                        // sums[beginindex] = footerDatum[clumn] ? footerDatum[clumn] : '';
                        beginindex ++;
                    });
                }
                return sums;
            },
            query(flag,column){
                if(this.queryClean){
                    this.tableData = [];
                }
                var params = this.getParams();
                if(params && params.url){
                    if(this.pagination){
                        if(!params.params){
                            params.params = {};
                        }
                        if(!flag){
                            this.pagobj.currentPage = 1;
                            if(column){
                                params.params.orderField = column.prop;
                                params.params.orderType = column.order;
                            }
                        }
                        this.checkMaxRow(params);
                        if(!this.localPage){
                            params.params.pageSize = this.pagobj.pageSize;
                            params.params.currentPage = this.pagobj.currentPage;
                        }else{
                            if(params.params.pageSize){
                                delete params.params['pageSize'];
                            }
                            if(params.params.currentPage){
                                delete params.params['currentPage'];
                            }
                        }
                    }
                    this.$emit('button-loading',true);
                    if(this.method == 'post'){
                        this.$httpService.post(params.url,params.params,{loading:this.loading,timeout:this.timeout}).then(res =>{
                            this.$emit('button-loading',false);
                            if(res){
                                if( this.pagination && this.localPage){
                                    this.localData = this.getSortTableData(params,res.list);
                                    this.setLocalData();
                                    this.pagobj.total = this.localData.length;
                                } else {
                                    this.tableData = this.getSortTableData(params,res.list);
                                    // this.tableData = res.list;
                                    this.$emit("after-load",this.tableData);
                                    if(this.tableData && this.tableData.length == 1) {
                                        this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                                        if(!this.singleSelect){
                                            this.$nextTick(() => {
                                                this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(this.tableData[0],true);
                                            })
                                        }
                                    }
                                    if(this.pagination){
                                        this.pagobj.total = res.total;
                                    }
                                }

                                if(this.showFooter){
                                    this.footerData = res.footer;
                                }
                                if(this.keepSort && this.sortObj.prop && this.sortObj.order && !column){
                                    this.sortChange(this.sortObj)
                                }
                                // if(flag){
                                    let that = this;
                                    //添加延时设置滚动条位置是为了防止切换页签后直接设置值无效
                                    setTimeout(() => {
                                        that.$refs['zmtable'].$el.querySelector('.el-table__body-wrapper').scrollTop = 0;
                                    },50)
                                // }
                            }
                        }).catch(res => {
                            this.tableData = [];
                            this.$emit('button-loading',false);
                            this.$emit("after-load",[]);
                        });
                    }else{
                        this.$httpService.get(params.url,params.params,{loading:this.loading,timeout:this.timeout}).then(res =>{
                            this.$emit('button-loading',false);
                            if(res){
                                if(this.pagination && this.localPage){
                                    this.localData = this.getSortTableData(params,res.list);
                                    this.setLocalData();
                                    this.pagobj.total = this.localData.length;
                                }else{
                                    this.tableData = this.getSortTableData(params,res.list);
                                    // this.tableData = res.list;
                                    this.$emit("after-load",this.tableData);
                                    if(this.tableData && this.tableData.length == 1) {
                                        this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                                        if(!this.singleSelect){
                                            this.$nextTick(() => {
                                                this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(this.tableData[0],true);
                                            })
                                        }
                                    }
                                    if(this.pagination){
                                        this.pagobj.total = res.total;
                                    }
                                }
                                if(this.showFooter){
                                    this.footerData = res.footer;
                                }
                                if(this.keepSort && this.sortObj.prop && this.sortObj.order && !column){
                                    this.sortChange(this.sortObj)
                                }
                                // if(flag){
                                    let that = this;
                                    //添加延时设置滚动条位置是为了防止切换页签后直接设置值无效
                                    setTimeout(() => {
                                        that.$refs['zmtable'].$el.querySelector('.el-table__body-wrapper').scrollTop = 0;
                                    },50)
                                // }
                            }
                        }).catch(res => {
                            this.tableData = [];
                            this.$emit('button-loading',false);
                            this.$emit("after-load",[]);
                        });
                    }
                }
            },
            setLocalData(){
                if(this.localData && this.localData.length > 0){
                    let start = 0;
                    let end = 50;
                    start = (this.pagobj.currentPage-1) * this.pagobj.pageSize;
                    end = this.pagobj.currentPage * this.pagobj.pageSize;

                    // this.pagobj.total = tmpList.length;
                    if(this.localData.length > this.pagobj.pageSize){
                        end = end > this.localData.length ? this.localData.length : end;
                        this.tableData = this.localData.slice(start,end);
                    }else{
                        this.tableData = this.localData;
                    }
                }else{
                    this.tableData = [];
                }
            },
            //检测最大行数
            checkMaxRow(params){
                if(params && params.sortField && params.sortValue && params.sortMaxRow){
                    this.pagobj.pageSize = params.sortMaxRow;
                    this.isNoQuery = true;
                }else{
                    if(this.isNoQuery && this.pagobj.pageSize >= 300){
                        this.pagobj.pageSize = 50;
                    }
                    this.isNoQuery = false;
                }
            },
            //表格数据排序
            getSortTableData(params,list){
                if(list && list.length > 0){
                    try {
                        if(params && params.sortField && params.sortValue){
                            let sortValues = params.sortValue.split("\n");
                            let nos = [];
                            let tempNoMap = {};
                            let existNos = [];
                            let existTempNos = [];
                            sortValues.forEach((item,index) => {
                                if(item){
                                    let trimno = $.trim(item);
                                    if(trimno){
                                        let upcaseNo = trimno.toUpperCase();
                                        if(nos.indexOf(upcaseNo) > -1){
                                            if(existTempNos.indexOf(upcaseNo) < 0){
                                                existTempNos.push(upcaseNo);
                                                existNos.push(trimno);
                                            }
                                        }else{
                                            nos.push(upcaseNo);
                                            tempNoMap[upcaseNo] = trimno;
                                        }
                                    }
                                }
                            });
                            //根据指定单号进行排序
                            if(nos.length > 0){
                                list.sort(function(a,b){
                                    return nos.indexOf(a[params.sortField].toUpperCase()) - nos.indexOf(b[params.sortField].toUpperCase());
                                });
                            }
                            //获取未获取到的单号 单号不区分大小写
                            let notValueNos = [];
                            let nosMap = {};
                            list.forEach((item,index) => {
                                if(item[params.sortField]){
                                    nosMap[item[params.sortField].toUpperCase()] = 1;
                                }
                            });
                            // console.log(nosMap);
                            nos.forEach((item,index) => {
                                if(!nosMap[item]){
                                    notValueNos.push(tempNoMap[item]);
                                }
                            });
                            if(notValueNos.length > 0 || existNos.length > 0){
                                //复制不存在单号，catch 防止报错
                                try {
                                    if(existNos && existNos.length > 0){
                                        let copyArr = notValueNos.concat(['']).concat(existNos);
                                        this.$zmClp.copy2(copyArr.join("\r\n"),'.el-message-box__btns .el-button');
                                    }else{
                                        this.$zmClp.copy2(notValueNos.join("\r\n"),'.el-message-box__btns .el-button');
                                    }
                                    /*//合并两个数据
                                    notValueNos.push.apply(notValueNos,existNos);
                                    //去重
                                    notValueNos = xeUtil.uniq(notValueNos);
                                    //复制单号
                                    this.$zmClp.copy2(notValueNos.join("\r\n"),'.el-message-box__btns .el-button');*/
                                } catch (e) {
                                    console.log(e)
                                }
                                //组装提示信息
                                let contextRow = [];
                                if(notValueNos.length > 0){
                                    contextRow.push(this.$t(this.i18nPage+'以下单号在查询结果中不存在：'));
                                    for(let i = 0;i<notValueNos.length;i++){
                                        contextRow.push(notValueNos[i]);
                                        if(i >= 9){
                                            break;
                                        }
                                    }
                                    if(notValueNos.length > 10){
                                        contextRow.push("... ，"+this.$t(this.i18nPage+'共')+notValueNos.length+this.$t(this.i18nPage+"笔"));
                                    }else{
                                        contextRow.push(this.$t(this.i18nPage+"共")+notValueNos.length+this.$t(this.i18nPage+"笔"));
                                    }
                                }
                                if(existNos.length > 0){
                                    contextRow.push(this.$t(this.i18nPage+'以下单号存在重复：'));
                                    for(let i = 0;i<existNos.length;i++){
                                        contextRow.push(existNos[i]);
                                        if(i >= 4){
                                            break;
                                        }
                                    }
                                    if(notValueNos.length > 5){
                                        contextRow.push("... ，"+this.$t(this.i18nPage+'共')+existNos.length+this.$t(this.i18nPage+"笔"));
                                    }else{
                                        contextRow.push(this.$t(this.i18nPage+"共")+existNos.length+this.$t(this.i18nPage+"笔"));
                                    }
                                }

                                //创建节点 <div><p></p><p></p></div> 形式
                                const h = this.$createElement;
                                let newDatas = [];
                                for(let i in contextRow) {
                                    //4.将data数据push进newDatas数组中
                                    newDatas.push(h('p', null, contextRow[i]));
                                }
                                this.$util.alert(h('div', null ,newDatas));
                            }
                        }
                    } catch (e) {
                        console.log(e)
                    }
                    return list;
                } else {
                    return [];
                }
            },
            getTableHeigth(){
                if(this.pagination){
                    this.tbHight = (window.innerHeight - 118- this.tableHeight) +'px';
                }else {
                    this.tbHight = (window.innerHeight - 86 - this.tableHeight) +'px';
                }
            },
            addRow(row){
                this.tableData.unshift(row);
                this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
            },
            appendRow(row){
                this.tableData.push(row);
            },
            deleteRow(row){
                var index = this.tableData.indexOf(row);
                this.tableData.splice(index,1);
            },
            appendRows(rows){
                if(rows && rows.length > 0){
                    rows.forEach(row => {
                        this.tableData.push(row);
                    });
                }
            },
            deleteRows(rows){
                if(rows && rows.length > 0){
                    rows.forEach(row => {
                        var index = this.tableData.indexOf(row);
                        this.tableData.splice(index,1);
                    });
                }
            },
            updateSelRow(row){
                if(row){
                    for(var key in row) {
                        if(this.currentRow[key]){
                            this.currentRow[key] = row[key];
                        }else{
                            this.$set(this.currentRow,key,row[key])
                        }
                    }
                }
            },
            deleteSelRow(){
                var index = this.tableData.indexOf(this.currentRow);
                this.tableData.splice(index,1);
                if(this.tableData.length > 0) {
                    this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                }
            },
            cancelSelection(rows) {
                if (!this.singleSelect && rows) {
                    rows.forEach(row => {
                        this.$refs['zmtable'].$refs['singleTable'].toggleRowSelection(row);
                    });
                }
            },
            openColMenu(col,row, e) {
                const menuMinWidth=105;
                const windowWidth = window.innerWidth;
                const maxLeft = windowWidth - menuMinWidth;
                const left = e.clientX;
                if (left > maxLeft) {
                    this.left = maxLeft
                } else {
                    this.left = left
                }
                this.top = e.clientY;

                this.visible = true;
                this.menuCol = col;
                this.menuRow = row;
            },
            copyColData(type,$event){
                let copyStr = '';
                let colf = this.menuCol;
                let rowf = this.menuRow;
                if(type == 1){
                    if(rowf[colf.value]){
                        if(colf.formatter){
                            copyStr += colf.formatter(rowf[colf.value],rowf);
                        }else if(colf.filter){
                            copyStr += this.$options.filters[colf.filter](rowf[colf.value])
                        }else{
                            copyStr += rowf[colf.value];
                        }
                    }
                }else if(type == 2){
                    this.tableData.forEach((item,index) => {
                        //当字段有值是获取对应的值，如果是有格式化和过滤 则组装处理后的值
                        if(item[colf.value]){
                            if(colf.formatter){
                                copyStr += colf.formatter(item[colf.value],item);
                            }else if(colf.filter){
                                copyStr += this.$options.filters[colf.filter](item[colf.value])
                            }else{
                                copyStr += item[colf.value];
                            }
                        }
                        copyStr += '\r\n';
                    });
                }else{
                    if(this.singleSelect){
                        if(this.currentRow && this.currentRow[colf.value]){
                            if(colf.formatter){
                                copyStr += colf.formatter(this.currentRow[colf.value],this.currentRow);
                            }else if(colf.filter){
                                copyStr += this.$options.filters[colf.filter](this.currentRow[colf.value])
                            }else{
                                copyStr += this.currentRow[colf.value];
                            }
                        }
                    }else {
                        if(this.multipleSelection && this.multipleSelection.length > 0){
                            this.multipleSelection.forEach((item,index) => {
                                //当字段有值是获取对应的值，如果是有格式化和过滤 则组装处理后的值
                                if(item[colf.value]){
                                    if(colf.formatter){
                                        copyStr += colf.formatter(item[colf.value],item);
                                    }else if(colf.filter){
                                        copyStr += this.$options.filters[colf.filter](item[colf.value])
                                    }else{
                                        copyStr += item[colf.value];
                                    }
                                }
                                copyStr += '\r\n';
                            });
                        }
                    }
                }
                this.$zmClp.copy(copyStr,$event);
            },
            closeColMenu() {
                this.visible = false
            },
            keydownListener(e){
                if(e.keyCode === 17){
                    this.isCtrl = true;
                }
                if(e.keyCode === 16){
                    this.isShift = true;
                }
            },
            keyupListener(e){
                if(e.keyCode === 17){
                    this.isCtrl = false;
                }
                if(e.keyCode == 16 ){
                    this.isShift = false;
                }
            },
            sortChange(column){
                if(this.keepSort){
                    this.sortObj.prop = column.prop;
                    this.sortObj.order = column.order;
                }
                let prop = column.prop;
                let order = column.order;
                if(prop && order){
                    if(this.colRemoteMap[column.prop]){
                        // this.$util.show('进入远程排序');
                        this.query(false,column);
                    }else{
                        if(this.tableData && this.tableData.length > 0){
                            let notNullDatas = [];
                            let nullDatas = []
                            this.tableData.forEach((item,index) => {
                                if(item[prop] || item[prop] === 0){
                                    notNullDatas.push(item);
                                } else {
                                    nullDatas.push(item);
                                }
                            });
                            if(notNullDatas.length > 0){
                                notNullDatas = xeUtil.sortBy(notNullDatas,prop);
                                if('descending' == order){
                                    notNullDatas.reverse();
                                }
                            }

                            if('descending' == order){
                                this.tableData = notNullDatas.concat(nullDatas);
                            }else{
                                this.tableData = nullDatas.concat(notNullDatas);
                            }
                        }
                    }
                }
            },
            openTableConfig(){
                let cellws = [];
                // let headerTrs = this.$refs['zmtable'].$el.children[1].children[0].children[1].children;
                let headerTrs = this.$refs['zmtable'].$el.children[0].children[0].children[1].children[0].children[1].children[0].children;
                // console.log(headerTrs)
                if(headerTrs && headerTrs.length > 0){
                    let headerRows = headerTrs.length;
                    for(let i = 0;i < headerRows;i++){
                        let cells = headerTrs[i].cells;
                        if(cells && cells.length > 0){
                            for(let j = 0;j < cells.length - 1;j++){
                                if(i === 0 && j === 0){
                                    continue;
                                }
                                if((cells[j].rowSpan + i) == headerRows){
                                    cellws.push({
                                        level: i+1,
                                        text:cells[j].innerText,
                                        width:cells[j].offsetWidth
                                    })
                                }
                            }
                        }
                    }
                }
                this.$refs['zmtbconfig'].openTableConfig(cellws);
            }
        },
        created(){
            let colsconfig = [];
            if(this.col && this.col.length){
                for (let i = 0; i < this.col.length; i++) {
                    let col1 = this.col[i];
                    if(col1.value){
                        this.colRemoteMap[col1.value] = col1.sortRemote || false;
                    }else{
                        if(col1.children && col1.children.length > 0){
                            for (let j = 0; j < col1.children.length; j++) {
                                let col2 = col1.children[j];
                                if(col2.value){
                                    this.colRemoteMap[col2.value] = col2.sortRemote || false;
                                }else{
                                    if(col2.children && col2.children.length > 0){
                                        for (let k = 0; k < col2.children.length; l++) {
                                            let col3 = col2.children[k];
                                            if(col3.value){
                                                this.colRemoteMap[col3.value] = col3.sortRemote || false;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if(this.tableNo){
                //组装列map
                if(this.col && this.col.length > 0) {
                    // console.log(this.col)
                    // let tempcols = JSON.parse(JSON.stringify(this.col));
                    // console.log(tempcols)

                    for (let i = 0; i < this.col.length; i++) {
                        let cell = Object.assign({},this.col[i]);
                        this.colMap[cell.text] = cell;
                    }
                }
                let userCols = this.$util.get("configTableNo:"+this.tableNo);
                if(userCols && userCols.length > 0){
                    let level1Cols = [];
                    let level2Cols = [];
                    let level3Cols = [];
                    userCols.forEach((item,index) =>{
                        switch (item.level){
                            case 1:
                                level1Cols.push(item);
                                break;
                            case 2:
                                level2Cols.push(item);
                                break;
                            case 3:
                                level3Cols.push(item);
                                break;
                        }
                    });
                    if(level1Cols && level1Cols.length > 0){
                        //一级列排序
                        level1Cols.sort((col1,col2) => {
                            return col1.sort - col2.sort;
                        });
                        //二级列排序
                        if(level2Cols && level2Cols.length > 0){
                            level2Cols.sort((col1,col2) => {
                                return col1.sort - col2.sort;
                            });
                        }
                        //三级列排序
                        if(level3Cols && level3Cols.length > 0){
                            level3Cols.sort((col1,col2) => {
                                return col1.sort - col2.sort;
                            });
                        }
                        //组装一级列
                        level1Cols.forEach((item,index) => {
                            let tempcol = this.colMap[item.text];
                            //判断列是否显示， 并且判断列信息是否存在， 防止表格列变化加载无效列
                            if(item.isshow === 1 && tempcol){
                                if(item.width && item.width > 0){
                                    tempcol.width = item.width;
                                }
                                //加入列有下级则组装下级列信息， 否则将列信息加入到配置信息中
                                if(tempcol.children && tempcol.children.length > 0 ){
                                    //加入下级列
                                    let child1cols = [];
                                    tempcol.children.forEach((child1,child1index) => {
                                        level2Cols.forEach((level2col,levle2index) => {
                                            if(level2col.width && level2col.width > 0){
                                                child1.width = level2col.width;
                                            }
                                            //判断是否是下级二级列并且为显示列
                                            if(level2col.isshow == 1 && level2col.parentText == item.text && level2col.text == child1.text){
                                                //判断二级列下面是否有3级列, 没有则之间加载二级列配置信息中
                                                if(child1.children && child1.children.length > 0 ){
                                                    let child2cols = [];
                                                    child1.children.forEach((child2,child2index) => {
                                                        level3Cols.forEach((level3col,levle3index) => {
                                                            if(level3col.width && level3col.width > 0){
                                                                child2.width = level3col.width;
                                                            }
                                                            if(level3Cols.isshow == 1 && level3Cols.parentText == child1.text && level3Cols.text == child2.text){
                                                                child2cols.push(child2);
                                                            }
                                                        })
                                                    });
                                                    //判断二级下面是否有3级列信息，没有则二级列作废
                                                    if(child2cols.length > 0){
                                                        child1.children = child2cols;
                                                        child1cols.push(child1);
                                                    }
                                                }else{
                                                    child1cols.push(child1);
                                                }
                                            }
                                        })
                                    });
                                    //判断一级下面是否有3级列信息，没有则一级列作废
                                    if(child1cols.length > 0){
                                        tempcol.children = child1cols
                                        colsconfig.push(tempcol)
                                    }
                                }else{
                                    colsconfig.push(tempcol);
                                }
                            }
                        });
                    }
                }
            }
            //如果列配置信息不为空则执行回调重新加载表格
            if(colsconfig && colsconfig.length > 0){
                this.tableflag = false;
                this.configCols = colsconfig;
                this.$nextTick(() => {
                    this.tableflag = true;
                    if(this.startQuery){
                        this.query();
                    }
                });
            }else{
                if(this.startQuery){
                    this.query();
                }
            }


            /*if(this.startQuery){
                this.query();
            }*/
            if(this.isAuto){
                this.getTableHeigth();
                window.addEventListener('resize', this.getTableHeigth);
            }else{
                if(this.pagination){
                    this.tbHight =  (this.tableHeight - 32) +'px';
                }else {
                    this.tbHight =  this.tableHeight +'px';
                }
            }
            if(!this.singleSelect){
                // var sUserAgent = navigator.userAgent;
                // var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
                // var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
                document.addEventListener('keydown',this.keydownListener)
                document.addEventListener('keyup', this.keyupListener)
            }
        },
        beforeDestroy(){
            this.tableData = [];
            this.footerData = [];
            this.currentRow = null
            this.multipleSelection = [];
            this.componentShow = false;
        },
        destroyed(){
            if(this.isAuto){
                window.removeEventListener('resize', this.getTableHeigth)
            }
            if(!this.singleSelect){
                document.removeEventListener('keydown',this.keydownListener)
                document.removeEventListener('keyup',this.keyupListener)
            }

        },
        activated(){
            this.tableScrollPosition = false;
            this.tableScrollPosition = true;
        },
        watch: {
            visible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeColMenu)
                } else {
                    document.body.removeEventListener('click', this.closeColMenu)
                }
            }
        }
    }
</script>
<style scoped>
    .contextmenu{
        margin: 0;
        background: #fff;
        z-index: 100;
        /*position: absolute;*/
        position: fixed;
        list-style: none;
        padding: 5px 0;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color:#333;
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    }
    .contextmenu li {
        margin: 0;
        padding: 1px 16px;
        cursor: pointer;
        display: block;
        line-height: 20px;
    }
    .contextmenu li:hover{
        background: #eee;
    }

</style>



// WEBPACK FOOTER //
// src/components/CommonTable/ZmTable.vue